
// SVG Icon: circlef-full
export default { id: "terriajs-circlef-full" };
export const id = "terriajs-circlef-full";
export const name = "circlef-full";
